<template>
  <v-card class="w-full">
    <v-tabs value="tab-2" centered>
      <v-tab href="#signin">サインイン</v-tab>
      <v-tab href="#signup">新規登録</v-tab>
      <v-tab-item value="signin" style="overflow-y: scroll;">
        <div class="tab-item-wrapper">
          <signinwithnumber />
        </div>
      </v-tab-item>
      <v-tab-item value="signup" style="overflow-y: scroll;">
        <div class="tab-item-wrapper">
          <signupwithnumber />
        </div>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import signupwithnumber from '../components/auth/Signupwithnumber.vue'
import signinwithnumber from '../components/auth/Signinwithnumber.vue'

export default {
  name: 'officerslogin',
  beforeCreate() {
    // 認証済みだったら一度サインアウト
    if (this.$store.state.auth?.isAuthed) {
      this.$store.dispatch('auth/logout');
    }
  },
  components: {
    signupwithnumber,
    signinwithnumber
  }
}

</script>

<style scoped>
.tab-item-wrapper {
  /* vuetify sets the v-tabs__container height to 48px */
  height: calc(100vh - 48px)
}
</style>